import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';

/**
 * Class responsible for manage the API calls and data request of the App
 */
export class DealersService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };
    /**
     * Instantiates a new ClientService
     */
    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    /**
     * Retrieves the dealer data
     * @param dealerId DealerId for funding widget
     */
    public async getDealerData(dealerId: string): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/getDealerData`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { dealerId, jwtToken: permissionsToken },
        };
        return this.client.sendRequest(request);
    }

    /**
     * Retrieves the user data
     * @param username user login
     * @param dealerId DealerId
     */
    public async getUserData(
        username: string,
        dealerId: string,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/getDealerUserDetail`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { username, dealerId, jwtToken: permissionsToken },
        };
        return this.client.sendRequest(request);
    }
}
